import React, { useCallback } from 'react';
import cn from 'classnames';
import { ExareStatus } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import { useTranslation } from 'react-i18next';
import { CdnIcon } from '@shared/ui';
const ExchangeRefundStates = ({ className, status, ns = 'Refund' }) => {
    const { t } = useTranslation(ns);
    const { ExchangeRefundStates: css } = useTheme('Entities').Order;
    const renderStatesIcon = useCallback(() => {
        switch (status) {
            case ExareStatus.InProcess:
            case ExareStatus.AwaitingPayment:
            case ExareStatus.NeedConfirm:
            case ExareStatus.TimelimitExpired:
                return React.createElement(CdnIcon, { icon: "Info/Time" });
            case ExareStatus.Finished:
                return React.createElement(CdnIcon, { icon: "Info/Item Icluded" });
            case ExareStatus.Rejected:
            case ExareStatus.Refused:
                return React.createElement(CdnIcon, { icon: "Info/Not included" });
        }
    }, [status]);
    return (React.createElement("div", { className: cn(css.root, className, css[status]) },
        React.createElement("div", { className: css.icon }, renderStatesIcon()),
        React.createElement("span", { className: css.text }, t(status))));
};
export default ExchangeRefundStates;
